// extracted by css-extract-rspack-plugin
export default {"isKeyboardDragging":"DragAndDropContainer-module__isKeyboardDragging__mcnIz","container":"DragAndDropContainer-module__container__zvZfn"};